import { ColorPicker } from './ColorPicker';
import { LandingMediaDropbox } from './MediaDropBox';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
import { useFormContext, Controller } from 'react-hook-form';
import { TwoColumns } from './layouts';

type Props = {
  imageUpload: (file: File) => Promise<string>;
};
export function BrandingForm({ imageUpload }: Props) {
  const { control } = useFormContext();

  const firstCol = (
    <>
      <Controller
        name={`branding.logo`}
        control={control}
        render={({
          field: { value, onChange, ref },
          fieldState: { error },
        }) => (
          <LandingMediaDropbox
            optional
            upload={imageUpload}
            inputRef={ref}
            label="Logo"
            validationText={
              <span>
                Upload your unique logo that represents you.
                <br />- PNG Format, transparent background. Should be fixed
                size: max 200px wide and 40px in height.
              </span>
            }
            value={value}
            onChange={onChange}
            type="image"
            icon={faImage}
            errorMsg={error?.message}
            short
            height="67px"
            width="100%"
          />
        )}
      />
    </>
  );

  const secondCol = (
    <Controller
      name={`branding.primaryColor`}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <ColorPicker
          value={value}
          onChange={onChange}
          error={Boolean(error?.message)}
        />
      )}
    />
  );

  return <TwoColumns first={firstCol} second={secondCol} />;
}
